/* ClearSight OLD "5 reasons why listicle" - vanilla re-implementation of gp-countdown-timer behaviour "daily"
 * (GemPages gp-countdown-v7-5.js, the build their page loads; cs-listicle.js only handles "evergreen").
 * Their timer gp-data: behaviour "daily", timerDaily {hours:10, mins:0, format:"am"}, enableHour/Minute/Second, no day/week,
 * loopAfterFinish true (only honoured for evergreen), autoHideWhenTimeout false, redirectUrl stay-on-page, gp-href empty.
 * daily = seconds until the next 10:00 AM in the VISITOR's local time (timeZone "UTC-4" is not used by this branch):
 *   target = today at hh:mm local; if already past, +24h; C = ceil(ms/1000). Hours shown = total hours, zero-padded.
 * Ticks every 1s (C -= 1). At C <= 0: no redirect (link empty), #section-countdown stays visible, interval cleared
 * (shows 00 00 00 until the next page load). Their script is a gps-link "delay" script inside the lazy section, so it
 * starts when that section is switched on (cs-listicle.js removes .gps-lazy); a timer outside a lazy section starts at load.
 */
(function () {
  'use strict';
  function pad(n) { return isNaN(n) || n === 0 ? '00' : (n < 10 ? '0' + n : '' + n); }
  function parse(h, m, f) {
    var p = (h + ':' + m + ' ' + f).toLowerCase().match(/\d+|[a-z]+/g) || [];
    var s = (Number(p[0]) % 12 + (p[2] == 'am' ? 0 : 12) + ':' + p[1]).split(':');
    return { hours: parseInt(s[0] ? s[0] : '0'), mins: parseInt(s[1] ? s[1] : '0') };
  }
  function secondsToDaily(t) {
    var now = new Date(), x = parse(t.hours, t.mins, t.format);
    var l = new Date(now.getFullYear(), now.getMonth(), now.getDate(), x.hours, x.mins).getTime() - now.getTime();
    if (l < 0) l += 864e5;
    return Math.ceil(l / 1e3);
  }
  function init(el) {
    if (el.__cs5rl) return; el.__cs5rl = true;
    var d = {};
    try { d = JSON.parse(el.getAttribute('gp-data')) || {}; } catch (e) {}
    if (d.behaviour !== 'daily' || !d.timerDaily) return;
    var C = secondsToDaily(d.timerDaily);
    var W = el.querySelector('#week .gp-countdown-number'), D = el.querySelector('#day .gp-countdown-number'),
        H = el.querySelector('#hour .gp-countdown-number'), M = el.querySelector('#minute .gp-countdown-number'),
        S = el.querySelector('#second .gp-countdown-number'), K = el.querySelector('#section-countdown');
    function render() {
      var s = Math.max(C, 0);
      var v = { seconds: s % 60, minutes: Math.floor(s / 60) % 60, hours: Math.floor(s / 3600) % 24, days: Math.floor(s / 86400) % 7,
                weeks: Math.floor(s / 604800), totalDays: Math.floor(s / 86400), totalHours: Math.floor(s / 3600), totalMinutes: Math.floor(s / 60) };
      if (W) W.textContent = pad(v.weeks);
      if (D) D.textContent = pad(d.enableWeek ? v.days : v.totalDays);
      if (H) H.textContent = pad(d.enableDay ? v.hours : v.totalHours);
      if (M) M.textContent = pad(d.enableHour || d.enableDay || d.enableWeek ? v.minutes : v.totalMinutes);
      if (S) S.textContent = pad(d.enableMinute || d.enableHour || d.enableDay || d.enableWeek ? v.seconds : s);
    }
    render();
    if (K && !(C <= 0 && d.autoHideWhenTimeout)) K.classList.remove('!gp-hidden');
    var iv = setInterval(function () {
      C -= 1; render();
      if (C <= 0) {
        clearInterval(iv);
        if (K) { if (d.autoHideWhenTimeout) K.classList.add('!gp-hidden'); else K.classList.remove('!gp-hidden'); }
      }
    }, 1000);
  }
  function start() {
    var t = document.querySelectorAll('gp-countdown-timer');
    Array.prototype.forEach.call(t, function (el) {
      var lazy = el.closest('.gps-lazy');
      if (!lazy) { init(el); return; }
      var mo = new MutationObserver(function () {
        if (!lazy.classList.contains('gps-lazy')) { mo.disconnect(); init(el); }
      });
      mo.observe(lazy, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
